import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import CloseButton from "../../styled-components/CloseButton";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.span`
  padding-left: 0.5rem;
  color: white;
`;

class ClipperHeader extends PureComponent {
  render() {
    return (
      <Container>
        <Title>{this.props.title}</Title>
        {this.props.close ? (
          <CloseButton onClick={this.props.close}>&times;</CloseButton>
        ) : (
          ""
        )}
      </Container>
    );
  }
}

ClipperHeader.defaultProps = {
  editMode: false,
  title: "",
  close: null
};

ClipperHeader.propTypes = {
  editMode: PropTypes.bool,
  title: PropTypes.string,
  close: PropTypes.func
};

export default ClipperHeader;



// WEBPACK FOOTER //
// ./app/components/Clipper/ClipperHeader.js